export function getTwitterProfileLink(handle) {
  if (!handle) {
    return null;
  }

  return `https://twitter.com/${handle}`;
}
